<template>
    <b-container class="p-0 rw-complete-story3" style="font-size: 1.3rem;">
        <b-row>
            <b-col cols="12" class="mb-2" v-if="qdata.image.data.src">
                <div class="question-item__image">
                    <img class="mw-100" :src="imageSrc(qdata.image.data.src)" alt="">
                </div>
            </b-col>
            <b-col cols="12" v-if="qdata.label2">
                <text-input class="" v-if="qdata.label2" :value="qdata.label2.data"/>
            </b-col>
        </b-row>
        <!-- <div class="question-example">
            <p><strong>Example:</strong></p>
            <div class="example__block">
                <p>Betty couldn’t wear her new skirt to school because she <input disabled value="dropped her cereal"/> on it.</p>
                <p class="m-0">When the students first saw their new teacher they <input disabled value="looked surprised"/></p>
            </div>
        </div> -->
        <b-row v-if="qdata.questions">
            <p class="text-start section-title mb-0"><strong>Questions</strong></p>
            <b-col cols="12" v-for="(item, index) in qdata.questions" :key="index" class="mb-2 border card p-2 mb-4 text-start">
                <p class="">{{index + 1}}. {{ item.question_text.data.value }}</p>
                <b-form-input type="text" autocomplete="off" @keydown="inputKeyDown($event)" v-model="result[index]" placeholder="typing..." />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import TextInput from './components/TextInput.vue'
// import TextInput2 from './components/TextInput2.vue'
import {
    // BRow,
    // BCol,
    // BCard,
    // BModal,
    BFormInput,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_complete_story2',
    data () {
        return {
            imageDefault: require('@/assets/img-default.jpg'),
            result: []
        }
    },
    components: {
        TextInput,
        // BRow,
        // BCol,
        // BCard,
        // BModal,
        // TextInput2,
        BFormInput,
        BContainer,
    },
    props: {
        qdata: Object
    },
    watch: {
        result () {
            this.$emit('input', {
                answers: this.result
            })
            // console.log(this.result)
        }
    },
    created() {
        for (let index = 0; index < this.qdata.questions.length; index++) {
            this.result[index] = null
        }
    },
    methods: {
        inputKeyDown(event) {
            console.log(event)
            // document.querySelector('input#inputfocus').focus()
            event.target.focus();
        },
        imageSrc (src) {
            if (src && src !== '') { return src }
            return this.imageDefault
        }
    }
}
</script>